import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableField/CheckableField.SecondaryAction.tsx
import { useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CheckableFieldSecondaryAction = _a => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  const {
    secondaryAction
  } = useContext(CheckableFieldContext);
  if (!secondaryAction) {
    return null;
  }
  return /* @__PURE__ */jsx("div", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd:checkable-field__secondary-action", className),
    children: secondaryAction
  }));
};
var CheckableField_SecondaryAction_default = CheckableFieldSecondaryAction;
export { CheckableField_SecondaryAction_default };